module.exports = __webpack_public_path__ + "static/media/rbank-corporate-onboarding.93c8fd45.PNG";